<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '@/utils/shadcn/lib/utils.ts'

defineOptions({
    compatConfig: { MODE: 3 },
})

const props = defineProps<{
  class?: HTMLAttributes['class']
}>()
</script>

<template>
    <div
        data-slot="dialog-header"
        :class="cn('flex flex-col gap-2 text-center sm:text-left', props.class)"
    >
        <slot></slot>
    </div>
</template>
